var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"link",attrs:{"to":_vm.to}},[_c('div',{staticClass:"shortcut",class:{inactive: !_vm.isActive}},[_c('div',{staticClass:"icon",class:( _obj = {}, _obj[_vm.icon] = true, _obj )}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])],1)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }